export const AUTOCOMPLETE_MAX_LIMIT = 50;
export const AUTOCOMPLETE_MIN_LIMIT = 1;
